<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">心率区间</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="content">
            <div class="item-box">
                <div class="bar bar1"></div>
                <div class="key">热身区间</div>
                <div class="value">97-115<span class="unit">次/分</span></div>
            </div>
            <div class="item-box">
                <div class="bar bar2"></div>
                <div class="key">有氧区间</div>
                <div class="value">116-134<span class="unit">次/分</span></div>
            </div>
            <div class="item-box">
                <div class="bar bar3"></div>
                <div class="key">耐力区间</div>
                <div class="value">135-154<span class="unit">次/分</span></div>
            </div>
            <div class="item-box">
                <div class="bar bar4"></div>
                <div class="key">无氧区间</div>
                <div class="value">155-173<span class="unit">次/分</span></div>
            </div>
            <div class="item-box">
                <div class="bar bar5"></div>
                <div class="key">极限区间</div>
                <div class="value">>=174<span class="unit">次/分</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'hrRange',
        methods: {
            back() {
                this.$router.back();
            },
        }
    }
</script>

<style scoped>

    .content {
        width: 345px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 16px auto 10px;
        position: relative;
    }

    .item-box {
        height: 51px;
        border-bottom: 1px solid #000000;
        position: relative;
    }

    .bar {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        top: 18px;
        left: 20px;
    }

    .bar1 {
        background-color: #33b9b6;
    }

    .bar2 {
        background-color: #1fd491;
    }

    .bar3 {
        background-color: #854fc9;
    }

    .bar4 {
        background-color: #feef4a;
    }

    .bar5 {
        background-color: #e64649;
    }

    .key {
        font-size: 15px;
        position: absolute;
        top: 16px;
        left: 46px;
    }

    .value {
        font-size: 15px;
        position: absolute;
        top: 16px;
        right: 20px;
    }

    .unit {
        color: #ffffff;
        opacity: 0.6;
        margin-left: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/hrRange.vue